import React from "react";
import "./styles.scss";
import { getLanguage } from "../../utils";

const lan = getLanguage();
const MenusCard = (props) => {
  return (
    <>
      <div
        className={`hne-menu-card-wrapper ${props.isSelect ? "active" : ""}`}
      >
        <div className="mcw-id">{props.id}</div>
        {lan === "si" && <div className="mcw-SI">{props.nameSI}</div>}
        <div className="mcw-EN">{props.nameEN}</div>
        <div className="mcw-category">{props.category}</div>
        <div className="mcw-status">{props.status}</div>
        <div className="mcw-edit" onClick={props.onClick}>
          {props.edit}
        </div>
      </div>
    </>
  );
};
export default MenusCard;
